// extracted by mini-css-extract-plugin
export var heroHeadline = "HeroHeadline-module--heroHeadline--LH7vb";
export var includePadding = "HeroHeadline-module--includePadding--f5LsC";
export var noTopPadding = "HeroHeadline-module--noTopPadding--FT_vx";
export var hasMenu = "HeroHeadline-module--has-menu--hvLbO";
export var menuWrapper = "HeroHeadline-module--menu-wrapper--2h7MB";
export var blockSubMenu = "HeroHeadline-module--block-sub-menu--1oyka";
export var heroContent = "HeroHeadline-module--hero-content--3RVha";